import React, { Component, Fragment } from 'react'

import InvoiceTableRow from '../../components/InvoiceTableRow/'
import { TableHeader, HeaderItem } from './styles'

class InvoiceTable extends Component {

  render() {
    const {
      headers,
      items,
      data,
      loading,
      error
    } = this.props

    return (
      <Fragment>
        <TableHeader>
          {headers.map((header, index) => {
            return <HeaderItem key={index}> {header}</HeaderItem>
          })}
        </TableHeader>

        {items.map(item => {
          return (
            <InvoiceTableRow
              key={item.id}
              item={item}
              headers={headers}
              data={data}
              loading={loading}
              error={error}
            />
          )
        })}
      </Fragment>
    )
  }
}

export default InvoiceTable



// WEBPACK FOOTER //
// ./src/components/InvoiceTable/index.js